import * as React from 'react';
import './breadcrumb.scss';

type Props = { paths: string[] };
export const Breadcrumb = ({ paths }: Props) => (
  <div className="cp-breadcrumb">
    {paths
      .filter(x => x)
      .map(p => (
        <span key={p}>{p}</span>
      ))}
  </div>
);
